import { MAIN_THEME } from '@styles';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface IPageTitleProps {
  text: string;
}

const useStyles = makeStyles()(() => ({
  title: {
    fonstSize: MAIN_THEME.fontSize.sm,
    fontFamily: MAIN_THEME.font.medium,
  },
}));

const PageTitle: React.FC<IPageTitleProps> = ({ text }) => {
  const { classes } = useStyles();
  return <h1 className={classes.title}>{text}</h1>;
};

export default PageTitle;
